import Events from '@utilities/events'

class SortSelectBox {
  constructor(element) {
    this.element = element;

    this.bindEvents();
  }

  /**
   * Replacing current history to the current visible grid
   * @param {url} url
   */
  static updateHistory(url) {
    Events.$trigger('history::push', {
      data: { url, state: { url } },
    });
  }

  /**
   * Replacing current history to the current visible grid
   * @param {url} url
   */
  static refinementsUpdate(url) {
    Events.$trigger('history::refinements-update', {
      data: {
        url,
        state: {
          url
        }
      },
    })
  }

  /**
   * On change update history + url
   * Replacing grid html > refinements.js
   */
  onSelectChange() {
    if (this.element.tagName !== 'SELECT' && !this.element.checked) return;
    const prettyUrl = this.element.options[this.element.selectedIndex].dataset.url;

    SortSelectBox.updateHistory(prettyUrl);
    SortSelectBox.refinementsUpdate(prettyUrl);
  }

  /**
   * Bind all general events
   */
  bindEvents() {
    this.element.addEventListener('change', (event) => {
      event.preventDefault();
      this.onSelectChange();
    });
  }
}

export default SortSelectBox;
